export default __webpack_public_path__ + "static/media/logo_district.ef704a49.png";